import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";

const PLANS = [
  { name: "Starter", price: "₹7,500", blurb: "Solo founders & local shops",
    features: ["3,000 AI credits / mo", "1 brand · 1 website", "30 posts / mo", "10 logos · 5 videos", "Email support"],
    cta: "Start Free Trial", highlight: false },
  { name: "Professional", price: "₹25,000", blurb: "Growing businesses",
    features: ["20,000 AI credits / mo", "4 brands · multi-channel", "300 posts / mo", "60 logos · 50 videos", "Priority support", "Analytics suite"],
    cta: "Start Free Trial", highlight: true },
  { name: "Agency", price: "₹50,000", blurb: "Marketing teams & agencies",
    features: ["75,000 AI credits / mo", "15 brands", "White-label client portal", "Team seats", "API access", "Dedicated CSM"],
    cta: "Talk to Sales", highlight: false },
];

export default function PricingPreview() {
  return (
    <section id="pricing" className="max-w-7xl mx-auto px-6 lg:px-8 py-28">
      <div className="text-center mb-16" data-reveal>
        <div className="text-xs uppercase tracking-[0.25em] text-indigo-400 mb-4">Pricing</div>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight">
          Cheaper than one designer. <br /><span className="shimmer-text">Stronger than ten.</span>
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {PLANS.map((p, i) => (
          <div
            key={p.name}
            data-reveal
            style={{ transitionDelay: `${i * 100}ms` }}
            className={`glass rounded-2xl p-8 flex flex-col tilt-card ${
              p.highlight ? "border-indigo-500/40 bg-gradient-to-b from-indigo-500/[0.07] to-transparent pulse-glow" : ""
            }`}
          >
            {p.highlight && (
              <div className="text-[10px] uppercase tracking-[0.25em] brand-gradient-text font-bold mb-3">
                Most Popular
              </div>
            )}
            <h3 className="font-heading font-black text-2xl">{p.name}</h3>
            <p className="text-sm text-white/50 mt-1">{p.blurb}</p>
            <div className="mt-6 flex items-baseline gap-2">
              <span className="font-heading font-black text-5xl">{p.price}</span>
              <span className="text-white/40 text-sm">/ month</span>
            </div>
            <ul className="mt-8 space-y-3 text-sm flex-1">
              {p.features.map((feat) => (
                <li key={feat} className="flex items-start gap-2 text-white/70">
                  <Check className="h-4 w-4 text-indigo-400 shrink-0 mt-1" />
                  {feat}
                </li>
              ))}
            </ul>
            <Link
              to="/register"
              data-testid={`pricing-cta-${p.name.toLowerCase()}`}
              className={`mt-8 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg text-sm font-semibold transition ${
                p.highlight ? "brand-gradient gradient-animate hover:opacity-90 glow-orange" : "glass hover:bg-white/5"
              }`}
            >
              {p.cta}
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
